// import io from 'socket.io-client';
import authentication, { AuthenticationClient } from "@feathersjs/authentication-client";
import { feathers } from "@feathersjs/feathers";
import socketio from "@feathersjs/socketio-client";
import { Services } from "types";
import { CustomServices } from "./types/customServices";
const io = require("socket.io-client"); // eslint-disable-line


// TODO: use https://github.com/feathersjs/feathers-configuration
const host = process.env.API_URL || "http://localhost:3030";
export const socket = io(host, {
  transports: ["websocket"],
  forceNew: true
});

type ServiceNameLiteral = `${Services}`;

export type ServiceTypes = {
  [key in Exclude<ServiceNameLiteral, keyof CustomServices>]: any; // Would be nice to fix this type at some point.
} & CustomServices;

// TODO This is copied directly from the authentication-client package code
// Its a workaround since for some reason my tslint does not recognize the interface 
// extension the package does. It compiles and runs but I get errors in the code. 
declare module '@feathersjs/feathers/lib/declarations' {
  interface Application<Services, Settings> {
    io?: any;
    rest?: any;
    authentication: AuthenticationClient;
    authenticate: AuthenticationClient['authenticate'];
    reAuthenticate: AuthenticationClient['reAuthenticate'];
    logout: AuthenticationClient['logout'];
  }
}

//>>>>>>>>>>> workaround end <<<<<<<<<<<// 

const client = feathers<ServiceTypes>();

// NOTE: the order is important: auth must be configured _after_ rest/socket

client.configure(
  socketio(socket, { timeout: 5000, reconnectionDelayMax: 10000 })
);

// Initialize custom methods
// client.service("<service_name>").methods("<method_name>");
client.service('course').methods('rearrangeSteps');
client.service('video').methods('getVimeoURL');
client.service('feedback').methods('submit');
client.service('bankid').methods('auth');
client.service('bankid').methods('login');
client.service('bankid').methods('associate');
client.service('bankid').methods('unlink');
client.service('bankid').methods('validate');
client.service('swedsec').methods('report');
client.service('evaluation').methods('export');
client.service('quiz').methods('generate');
client.service('quiz').methods('validate');
client.service('statistics').methods('getTreeData');
client.service('progress').methods('completeCourse');

// Configure authentication
client.configure(
  authentication({
    storage: window.localStorage
  })
);

// socket.on("connect", () => {
//   console.log('Socket.io connected', socket.id);
// });

// socket.on("reconnect", (attempt:any) => {
//   console.log('Socket.io reconnect attempt', attempt)
// });

// socket.on("error", (error:any) => {
//   console.log('Socket.io error', error)
// });

// socket.on("connect_error", (error:any) => {
//   console.log('Socket.io connect_error', error)
// });



export default client;
